import { cn } from '@/shared/helpers';

import {
  BufferedFieldInput,
  flushClassName,
  isValuePresent,
  type FieldInputValue,
} from '../field-input';
import { type ActionParam } from '../field-registry';

interface ActionParamFieldProps {
  param: ActionParam;
  value: FieldInputValue;
  fresh: boolean;
  onChange: (value: FieldInputValue) => void;
}

/** One action parameter as a flush card cell, labelled only by its placeholder. */
export function ActionParamField({ param, value, fresh, onChange }: ActionParamFieldProps) {
  const required = param.required ?? false;
  const missing = required && !isValuePresent(value);

  const showIncomplete = missing && !fresh;

  return (
    <BufferedFieldInput
      className={cn('w-full', flushClassName)}
      aria-label={param.label}
      aria-invalid={showIncomplete ? true : undefined}
      descriptor={param.input}
      value={value}
      placeholder={param.label}
      onChange={onChange}
    />
  );
}
